import { DatePickerHeader as e } from "./date-picker-header.js";
import { jsx as t } from "react/jsx-runtime";
import n from "react-datepicker";
//#region src/date-picker/primitive/calendar.tsx
var r = ({ intlLocale: r, ...i }) => /* @__PURE__ */ t(n, {
	inline: !0,
	renderCustomHeader: ({ date: n, decreaseMonth: i, increaseMonth: a, monthDate: o, nextMonthButtonDisabled: s, prevMonthButtonDisabled: c }) => /* @__PURE__ */ t(e, {
		date: o ?? n,
		decreaseMonth: i,
		increaseMonth: a,
		intlLocale: r,
		nextMonthButtonDisabled: s,
		prevMonthButtonDisabled: c
	}),
	...i
});
r.displayName = "Calendar";
var i = ({ intlLocale: r, ...i }) => /* @__PURE__ */ t(n, {
	monthsShown: 2,
	inline: !0,
	renderCustomHeader: ({ date: n, decreaseMonth: i, increaseMonth: a, monthDate: o, nextMonthButtonDisabled: s, prevMonthButtonDisabled: c, customHeaderCount: l }) => /* @__PURE__ */ t(e, {
		date: o ?? n,
		decreaseMonth: i,
		increaseMonth: a,
		intlLocale: r,
		hidePrevButton: l === 1,
		hideNextButton: l === 0,
		nextMonthButtonDisabled: s,
		prevMonthButtonDisabled: c
	}),
	...i
});
i.displayName = "DoubleCalendar";
//#endregion
export { r as Calendar, i as DoubleCalendar };
